module.exports = __webpack_public_path__ + "static/media/Enigma.a42f681e.png";